import PropTypes from 'prop-types';
import { Backdrop, CircularProgress } from '@mui/material';

const Props = {
  isLoading: PropTypes.bool,
  children: PropTypes.element,
};

/** @param {PropTypes.InferProps<typeof Props>} props */
function LoadingScreen({ isLoading, children }) {
  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return children ? children : <></>;
};

LoadingScreen.defaultProps = {
  isLoading: false
};

LoadingScreen.propTypes = Props;

export default LoadingScreen;
